<div class="min-vh-100 bg-light py-3 py-md-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-10 col-xl-8">
        <mat-card class="shadow border-0">
          <!-- Header -->
          <mat-card-header
            class="justify-content-center px-3 px-md-4 py-3 py-md-4"
          >
            <div class="d-flex flex-column align-items-center">
              <mat-icon
                class="text-primary mb-2 mb-md-3 mat-icon-2xl mat-icon-lg-mobile"
                >account_circle</mat-icon
              >
              <mat-card-title
                class="h5 h4-md fw-bold text-primary mb-2 mb-md-3 text-center"
                >Complete Your Account Setup</mat-card-title
              >
              <mat-card-subtitle
                class="text-muted text-center mb-1 mb-md-2 small"
              >
                Please provide your information to create your digital business
                card account
              </mat-card-subtitle>
            </div>
          </mat-card-header>

          <!-- Mat Stepper -->
          <mat-card-content class="px-3 px-md-5">
            <mat-stepper 
              orientation="horizontal" 
              [linear]="true"
              #stepper
              class="custom-mat-stepper">
              
              <!-- Step 1: Account Type Selection -->
              <mat-step [stepControl]="accountTypeForm" label="Account Type">
                <ng-template matStepLabel>Account Type</ng-template>
                
                <h5 class="fw-bold mb-3 fs-5">Choose Your Account Type</h5>

                <form [formGroup]="accountTypeForm" class="needs-validation">
                  <!-- Account Type Selection -->
                  <div class="row mb-3 mb-md-4">
                    <div class="col-12">
                      <h6 class="fw-semibold mb-3 fs-6">Select Account Type</h6>
                      <mat-radio-group
                        formControlName="accountType"
                        class="w-100"
                      >
                        <div class="account-type-list">
                          <div
                            *ngFor="let type of accountTypes; let last = last"
                            class="account-type-item"
                            [class.mb-3]="!last"
                          >
                            <mat-card
                              class="account-type-card cursor-pointer"
                              [class.selected]="
                                accountTypeForm.get('accountType')?.value ===
                                type.value
                              "
                              (click)="
                                accountTypeForm
                                  .get('accountType')
                                  ?.setValue(type.value)
                              "
                            >
                              <mat-card-content class="p-3">
                                <div class="d-flex align-items-center">
                                  <mat-icon
                                    class="text-primary me-3 mat-icon-lg"
                                    >{{ type.icon }}</mat-icon
                                  >
                                  <div class="flex-grow-1">
                                    <h6 class="fw-bold mb-1 fs-6">
                                      {{ type.label }}
                                    </h6>
                                    <p
                                      class="text-muted mb-0"
                                      style="font-size: 0.875rem"
                                    >
                                      {{ type.description }}
                                    </p>
                                  </div>
                                  <mat-radio-button
                                    [value]="type.value"
                                    class="ms-2"
                                    style="pointer-events: none"
                                  >
                                  </mat-radio-button>
                                </div>
                              </mat-card-content>
                            </mat-card>
                          </div>
                        </div>
                      </mat-radio-group>
                      <mat-error
                        *ngIf="
                          accountTypeForm.get('accountType')?.invalid &&
                          accountTypeForm.get('accountType')?.touched
                        "
                      >
                        Please select an account type
                      </mat-error>
                    </div>
                  </div>
                </form>
                
                <div class="d-flex justify-content-end mt-4">
                  <button mat-raised-button color="primary" matStepperNext>Next</button>
                </div>
              </mat-step>

              <!-- Step 2: Personal Information -->
              <mat-step [stepControl]="personalInfoForm" label="Personal Information">
                <ng-template matStepLabel>Personal Information</ng-template>
                
                <h5 class="fw-bold mb-3 fs-5">Personal Information</h5>

                <form [formGroup]="personalInfoForm" class="needs-validation">
                  <!-- Personal Information Row -->
                  <div class="row mb-3 mb-md-4">
                    <!-- Display Name Field -->
                    <div class="col-12 col-md-6 mb-4 mb-md-0">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Full Name</mat-label>
                        <input
                          matInput
                          formControlName="displayName"
                          placeholder="Enter your full name"
                          autocomplete="name"
                        />
                        <mat-icon matSuffix>person</mat-icon>
                        <mat-error
                          *ngIf="
                            personalInfoForm.get('displayName')?.invalid &&
                            personalInfoForm.get('displayName')?.touched
                          "
                        >
                          {{ getErrorMessage("displayName", personalInfoForm) }}
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <!-- Email Field -->
                    <div class="col-12 col-md-6 mb-4 mb-md-0">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Email Address</mat-label>
                        <input
                          matInput
                          formControlName="email"
                          placeholder="Enter your email address"
                          autocomplete="email"
                          [readonly]="
                            firebaseUser?.emailVerified && firebaseUser?.email
                          "
                        />
                        <mat-icon matSuffix>
                          <span *ngIf="firebaseUser?.emailVerified"
                            >verified</span
                          >
                          <span *ngIf="!firebaseUser?.emailVerified">email</span>
                        </mat-icon>
                        <mat-error
                          *ngIf="
                            personalInfoForm.get('email')?.invalid &&
                            personalInfoForm.get('email')?.touched
                          "
                        >
                          {{ getErrorMessage("email", personalInfoForm) }}
                        </mat-error>
                        <mat-hint
                          *ngIf="!firebaseUser?.emailVerified"
                          class="text-muted"
                          >This will be your primary email for notifications</mat-hint
                        >
                        <mat-hint
                          *ngIf="firebaseUser?.emailVerified"
                          class="text-success"
                        >
                          <mat-icon class="me-1 mat-icon-xs"
                            >check_circle</mat-icon
                          >
                          Email verified by Google
                        </mat-hint>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Mobile Number Row -->
                  <div class="row mb-4">
                    <div class="col-12 col-md-6 mb-4 mb-md-0">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Mobile Number *</mat-label>
                        <input
                          matInput
                          formControlName="mobileNumber"
                          placeholder="+91 9876543210"
                          autocomplete="tel"
                        />
                        <mat-icon matSuffix>smartphone</mat-icon>
                        <mat-error
                          *ngIf="
                            personalInfoForm.get('mobileNumber')?.invalid &&
                            personalInfoForm.get('mobileNumber')?.touched
                          "
                        >
                          {{ getErrorMessage("mobileNumber", personalInfoForm) }}
                        </mat-error>
                        <mat-hint class="text-muted">Your primary mobile number for account</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                </form>
                
                <div class="d-flex justify-content-between mt-4">
                  <button mat-stroked-button matStepperPrevious>Back</button>
                  <button 
                    mat-raised-button 
                    color="primary" 
                    matStepperNext
                    *ngIf="accountTypeForm.get('accountType')?.value !== 'individual'">
                    Next
                  </button>
                  <button 
                    mat-raised-button 
                    color="primary"
                    (click)="onSubmit()"
                    *ngIf="accountTypeForm.get('accountType')?.value === 'individual'"
                    [disabled]="isLoading || personalInfoForm.invalid">
                    <span *ngIf="!isLoading">Create Account</span>
                    <span *ngIf="isLoading" class="d-flex align-items-center">
                      <mat-spinner diameter="20" class="me-2" color="warn"></mat-spinner>
                      Creating...
                    </span>
                  </button>
                </div>
              </mat-step>

              <!-- Step 3: Organization Details -->
              <mat-step 
                [stepControl]="organizationForm" 
                label="Organization Details"
                *ngIf="accountTypeForm.get('accountType')?.value !== 'individual'">
                <ng-template matStepLabel>Organization Details</ng-template>
                
                <h5 class="fw-bold mb-3 mb-md-4 fs-6 fs-md-5">
                  {{
                    accountTypeForm.get("accountType")?.value === "agency"
                      ? "Agency"
                      : "Corporate"
                  }}
                  Information
                </h5>

                <form [formGroup]="organizationForm" class="needs-validation">
                  <!-- Organization Name -->
                  <div class="row mb-4">
                    <div class="col-12">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>
                          {{
                            accountTypeForm.get("accountType")?.value === "agency"
                              ? "Agency"
                              : "Company"
                          }}
                          Name
                        </mat-label>
                        <input
                          matInput
                          formControlName="name"
                          placeholder="Enter organization name"
                        />
                        <mat-icon matSuffix>business</mat-icon>
                        <mat-error
                          *ngIf="
                            organizationForm.get('name')?.invalid &&
                            organizationForm.get('name')?.touched
                          "
                        >
                          {{ getErrorMessage("name", organizationForm) }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Company Type (for Corporate only) -->
                  <div
                    *ngIf="
                      accountTypeForm.get('accountType')?.value === 'corporate'
                    "
                    class="row mb-4"
                  >
                    <div class="col-12 col-md-6">
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Company Type</mat-label>
                        <mat-select formControlName="companyType">
                          <mat-option
                            *ngFor="let type of companyTypes"
                            [value]="type.value"
                          >
                            {{ type.label }}
                          </mat-option>
                        </mat-select>
                        <mat-icon matSuffix>business_center</mat-icon>
                        <mat-error
                          *ngIf="
                            organizationForm.get('companyType')?.invalid &&
                            organizationForm.get('companyType')?.touched
                          "
                        >
                          {{ getErrorMessage("companyType", organizationForm) }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <!-- Legal Information -->
                  <div class="mb-4">
                    <h6 class="fw-semibold text-dark mb-3">
                      {{
                        accountTypeForm.get("accountType")?.value === "agency"
                          ? "Personal Information"
                          : "Legal Information"
                      }}
                    </h6>
                    <div class="row">
                      <div class="col-12 col-md-6 mb-3">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>PAN Number</mat-label>
                          <input
                            matInput
                            formControlName="panNumber"
                            placeholder="ABCDE1234F"
                            style="text-transform: uppercase"
                          />
                          <mat-icon matSuffix>verified_user</mat-icon>
                          <mat-error
                            *ngIf="
                              organizationForm.get('panNumber')?.invalid &&
                              organizationForm.get('panNumber')?.touched
                            "
                          >
                            {{ getErrorMessage("panNumber", organizationForm) }}
                          </mat-error>
                          <mat-hint
                            >10-character alphanumeric PAN number</mat-hint
                          >
                        </mat-form-field>
                      </div>

                      <!-- Aadhar Number for Agency -->
                      <div 
                        class="col-12 col-md-6 mb-3"
                        *ngIf="accountTypeForm.get('accountType')?.value === 'agency'">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Aadhar Number</mat-label>
                          <input
                            matInput
                            formControlName="aadharNumber"
                            placeholder="1234 5678 9012"
                            type="tel"
                          />
                          <mat-icon matSuffix>credit_card</mat-icon>
                          <mat-error
                            *ngIf="
                              organizationForm.get('aadharNumber')?.invalid &&
                              organizationForm.get('aadharNumber')?.touched
                            "
                          >
                            {{ getErrorMessage("aadharNumber", organizationForm) }}
                          </mat-error>
                          <mat-hint>12-digit Aadhar identification number</mat-hint>
                        </mat-form-field>
                      </div>

                      <!-- GST Number for Corporate -->
                      <div 
                        class="col-12 col-md-6 mb-3"
                        *ngIf="accountTypeForm.get('accountType')?.value === 'corporate'">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>GST Number</mat-label>
                          <input
                            matInput
                            formControlName="gstNumber"
                            placeholder="22AAAAA0000A1Z5"
                            style="text-transform: uppercase"
                          />
                          <mat-icon matSuffix>receipt</mat-icon>
                          <mat-error
                            *ngIf="
                              organizationForm.get('gstNumber')?.invalid &&
                              organizationForm.get('gstNumber')?.touched
                            "
                          >
                            {{ getErrorMessage("gstNumber", organizationForm) }}
                          </mat-error>
                          <mat-hint
                            >15-character GST identification number</mat-hint
                          >
                        </mat-form-field>
                      </div>

                      <!-- CIN for Corporate -->
                      <div
                        class="col-12 col-md-6 mb-3"
                        *ngIf="
                          accountTypeForm.get('accountType')?.value ===
                          'corporate'
                        "
                      >
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label
                            >Corporate Identification Number (CIN)</mat-label
                          >
                          <input
                            matInput
                            formControlName="cin"
                            placeholder="U12345AB1234PTC123456"
                            style="text-transform: uppercase"
                          />
                          <mat-icon matSuffix>corporate_fare</mat-icon>
                          <mat-error
                            *ngIf="
                              organizationForm.get('cin')?.invalid &&
                              organizationForm.get('cin')?.touched
                            "
                          >
                            {{ getErrorMessage("cin", organizationForm) }}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <!-- Address Information -->
                  <div class="mb-4">
                    <h6 class="fw-semibold text-dark mb-3">
                      Address Information
                    </h6>
                    <div class="row">
                      <div class="col-12 mb-3">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Address</mat-label>
                          <textarea
                            matInput
                            formControlName="address"
                            rows="2"
                            placeholder="Enter complete address"
                          >
                          </textarea>
                          <mat-icon matSuffix>location_on</mat-icon>
                          <mat-error
                            *ngIf="
                              organizationForm.get('address')?.invalid &&
                              organizationForm.get('address')?.touched
                            "
                          >
                            {{ getErrorMessage("address", organizationForm) }}
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12 col-md-4 mb-3">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>City</mat-label>
                          <input
                            matInput
                            formControlName="city"
                            placeholder="Enter city"
                          />
                          <mat-icon matSuffix>location_city</mat-icon>
                          <mat-error
                            *ngIf="
                              organizationForm.get('city')?.invalid &&
                              organizationForm.get('city')?.touched
                            "
                          >
                            {{ getErrorMessage("city", organizationForm) }}
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12 col-md-4 mb-3">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>State</mat-label>
                          <input
                            matInput
                            formControlName="state"
                            placeholder="Enter state"
                          />
                          <mat-icon matSuffix>map</mat-icon>
                          <mat-error
                            *ngIf="
                              organizationForm.get('state')?.invalid &&
                              organizationForm.get('state')?.touched
                            "
                          >
                            {{ getErrorMessage("state", organizationForm) }}
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="col-12 col-md-4 mb-3">
                        <mat-form-field appearance="outline" class="w-100">
                          <mat-label>Pincode</mat-label>
                          <input
                            matInput
                            formControlName="pincode"
                            placeholder="123456"
                            type="tel"
                          />
                          <mat-icon matSuffix>pin_drop</mat-icon>
                          <mat-error
                            *ngIf="
                              organizationForm.get('pincode')?.invalid &&
                              organizationForm.get('pincode')?.touched
                            "
                          >
                            {{ getErrorMessage("pincode", organizationForm) }}
                          </mat-error>
                          <mat-hint>6-digit postal code</mat-hint>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <!-- Duplicate Check Warning -->
                  <mat-card
                    class="border-warning bg-warning-light mb-4"
                    *ngIf="checkForDuplicates()"
                  >
                    <mat-card-content class="p-3">
                      <div class="d-flex align-items-start">
                        <mat-icon class="text-warning me-2">warning</mat-icon>
                        <div>
                          <h6 class="fw-bold text-warning mb-1">
                            Duplicate Registration Detected
                          </h6>
                          <p class="text-warning mb-0 small">
                            An organization with the same PAN, GST, CIN, or Aadhar number
                            already exists. Please verify your information.
                          </p>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </form>
                
                <div class="d-flex justify-content-between mt-4">
                  <button mat-stroked-button matStepperPrevious>Back</button>
                  <button 
                    mat-raised-button 
                    color="primary"
                    (click)="onSubmit()"
                    [disabled]="isLoading || organizationForm.invalid">
                    <span *ngIf="!isLoading">Create Account</span>
                    <span *ngIf="isLoading" class="d-flex align-items-center">
                      <mat-spinner diameter="20" class="me-2" color="warn"></mat-spinner>
                      Creating...
                    </span>
                  </button>
                </div>
              </mat-step>
            </mat-stepper>
          </mat-card-content>

          <!-- Available Data Section -->
          <mat-card-content class="px-4 px-md-5 pt-0" *ngIf="firebaseUser">
            <div class="mb-4">
              <div class="bg-light rounded-3 p-3">
                <mat-chip-set class="d-flex flex-row gap-2">
                  <mat-chip
                    *ngIf="firebaseUser.email"
                    color="primary"
                    selected
                    class="d-flex align-items-center justify-content-center"
                  >
                    <mat-icon matChipAvatar>email</mat-icon>
                    <span class="small">{{ firebaseUser.email }}</span>
                  </mat-chip>
                  <mat-chip
                    *ngIf="firebaseUser.displayName"
                    color="primary"
                    selected
                    class="d-flex align-items-center"
                  >
                    <mat-icon matChipAvatar>person</mat-icon>
                    <span class="small">{{ firebaseUser.displayName }}</span>
                  </mat-chip>
                  <mat-chip
                    *ngIf="firebaseUser.phoneNumber"
                    color="primary"
                    selected
                    class="d-flex align-items-center"
                  >
                    <mat-icon matChipAvatar>smartphone</mat-icon>
                    <span class="small">{{ firebaseUser.phoneNumber }}</span>
                  </mat-chip>
                  <mat-chip
                    *ngIf="firebaseUser.emailVerified"
                    color="accent"
                    selected
                    class="d-flex align-items-center"
                  >
                    <mat-icon matChipAvatar>verified</mat-icon>
                    <span class="small">Email Verified</span>
                  </mat-chip>
                </mat-chip-set>
              </div>
            </div>
          </mat-card-content>

          <!-- Terms and Privacy -->
          <mat-card-footer class="bg-light border-top">
            <div class="p-4 text-center">
              <p class="text-muted small mb-3">
                By creating your account, you agree to our
                <a href="#" class="text-primary text-decoration-none fw-medium"
                  >Terms of Service</a
                >,
                <a href="#" class="text-primary text-decoration-none fw-medium"
                  >Privacy Policy</a
                >, and
                <a href="#" class="text-primary text-decoration-none fw-medium"
                  >Support</a
                >.
              </p>
              <div
                class="d-flex align-items-center justify-content-center text-success small"
              >
                <mat-icon class="me-2 mat-icon-lg">security</mat-icon>
                <span class="fw-medium"
                  >Your information is encrypted and securely stored</span
                >
              </div>
            </div>
          </mat-card-footer>
        </mat-card>
      </div>
    </div>
  </div>
</div>
